<template>
  <div class="input--wrap"
       :class="[`label-${labelPosition}`, {'above-input': isInputAbove}]">
    <label :for="id" class="label"><slot /></label>
    <div class="input-element"
         :class="{error: modelError}">
      <input autocomplete="true"
             :disabled="disabled"
             :type="pwShowToggle ? 'password' : 'text'"
             :id="id"
             :placeholder="placeholder"
             :name="name"
             v-model.trim="model"
             ref="input"
             @focus="onFocus"
             @blur="onBlur"
             @keyup.enter="onEnter"/>
      <i v-if="model.length && type !== 'password'"
         class="icon icon--close14"
         @click="model = ''"></i>
      <i v-if="type === 'password'"
         class="icon icon--pw-eye"
         :class="{on: !toggleInputType}"
         @click="toggleInputType = !toggleInputType"></i>
      <strong v-if="modelError.length" class="validation-text">{{ $t(`common.validationErrorText.${modelError}`) }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isInputAbove: {
      type: Boolean,
      default: true,
      required: false
    },
    labelPosition: {
      type: String, // top, left
      default: 'top',
      required: false
    },
    type: {
      type: String,
      default: 'text',
      required: true
    },
    id: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: 'Please enter text',
      required: false
    },
    name: {
      type: String,
      default: 'inputValue',
      required: false
    },
    modelValue: {
      type: String,
      default: '',
      required: false
    },
    modelError: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    lower: {
      type: Boolean,
      default: false,
      required: false
    },
    autoFocus: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    model (value) {
      const newValue = this.lower ? value.toLowerCase() : value
      this.$emit('input', newValue)
      this.model = newValue
    },
    modelValue (value) {
      this.model = this.modelValue
    }
  },
  data () {
    return {
      model: '',
      toggleInputType: true
    }
  },
  created () {
    if (this.modelValue) {
      this.model = this.modelValue
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.input && this.$refs.input.focus()
      })
    }
  },
  computed: {
    pwShowToggle () {
      if (this.type === 'text') {
        return false
      } else {
        return this.toggleInputType
      }
    }
  },
  methods: {
    onFocus () {
      this.$emit('onFocus')
    },
    onBlur () {
      this.$emit('onBlur')
    },
    onEnter () {
      this.$emit('onEnter')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.input--wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  text-align: left;
  margin: 0 auto;

  &.label-left {
    @include flexYcenter;
    justify-content: center;
    .label {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 0;
    }
    input {
      display: inline-block;
    }

    &.above-input {
      margin-top: 40px;
    }
  }

  &.above-input {
    margin-top: 22px;
  }

  .label {
    display: inline-block;
    font-weight: bold;
    padding-left: 5px;
    margin-bottom: 5px;
    font-size: 13px;
    color: #767676;
  }

  .input-element {
    position: relative;
    width: 100%;
    &.error {
      input {
        border-color: $errorColor;
      }
      .validation-text {
        color: $errorColor;
      }
    }

    input:focus::-webkit-textfield-decoration-container {
      visibility: hidden;
    }

    input {
      display: block;
      width: 100%;
      height: 38px;
      line-height: 36px;
      border-radius: 6px;
      border: solid 1px #bbbbbb;
      background-color: #ffffff;
      font-size: 14px;
      padding-left: 12px;
      padding-right: 40px;
      box-sizing: border-box;

      &::placeholder {
        font-family: system-ui;
      }

      &::-ms-clear {
        display: none;
      }
      &::-ms-reveal {
        display: none;
      }

      &:focus {
        border-color: #289eef;
      }

      &[disabled] {
        background-color: #d7d7d7;
        opacity: 0.3;
      }
    }
  }

  .icon--check-green-size16 {
    display: none;
  }

  .icon--close14,
  .icon--check-green-size16{
    position: absolute;
    top: calc(50% - 16px);
    right: 2px;
    padding: 9px 12px;
    cursor: pointer;
    background-position: center;
    background-color: transparent;
  }

  .icon--pw-eye {
    position: absolute;
    top: 0;
    right: 2px;
    padding: 6px 0px 6px 12px;
    cursor: pointer;
    background-position: center;
    background-color: transparent;
  }

  .validation-text {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    padding-left: 5px;
    font-weight: bold;
  }
}
</style>
